import React from 'react';
import { SvgIconProps } from '../type';
import useDesignTokens from '../../themes/useDesignTokens';

function ArrowBackButton({
  width = 20,
  height = 20,
  color,
}: Readonly<SvgIconProps>) {
  const tokens = useDesignTokens();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8337 10.0001H4.16699M4.16699 10.0001L10.0003 15.8334M4.16699 10.0001L10.0003 4.16675"
        stroke={color ?? tokens.components.button.tertiary.default.fg.default}
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ArrowBackButton;
